export function hasCorrectiveActionPerforms(
  source: { performs?: readonly unknown[] | null; isCompleted?: boolean } | null | undefined
): boolean {
  return (source?.performs?.length ?? 0) > 0 || !!source?.isCompleted;
}
